module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Bold-Oblique.a9cacc8d.woff2";